import { defineComponent, watch } from 'vue';
import useParentComponentEffect from '../../../hooks/useParentComponentEffect';

var script = /*#__PURE__*/ defineComponent(Object.assign({
    name: 'BNavigation3d'
}, { __name: 'index', props: {
        anchor: { type: null, required: false, default: 'BMAP_ANCHOR_BOTTOM_RIGHT' },
        offset: { type: Object, required: false, default: () => ({ x: 83, y: 18 }) },
        visible: { type: Boolean, required: false, default: true }
    }, emits: ['initd', 'unload'], setup(__props) {
        const props = __props;
        let navigation3dControl;
        const { ready } = useParentComponentEffect((map) => {
            const { visible, offset, anchor } = props;
            navigation3dControl = new BMapGL.NavigationControl3D({
                offset: new BMapGL.Size(offset.x, offset.y),
                anchor: window[anchor]
            });
            visible && map.addControl(navigation3dControl);
            ready(map, navigation3dControl);
            watch(() => props.visible, (n) => {
                map[n ? 'addControl' : 'removeControl'](navigation3dControl);
            });
            return () => map.removeControl(navigation3dControl);
        });
        return (_ctx, _cache) => {
            return null;
        };
    } }));

script.__file = "packages/components/control/navigation3d/index.vue";

export { script as default };
